import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CurationService } from '@bioconnect-ui/curation-service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    CardModule,
  ],
  selector: 'bioconnect-ui-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatisticsComponent implements OnInit {

  totalStudies = '';
  totalAssays = '';
  totalFiles = '';
  totalProtocols = '';

  // Scoped design token for the stat cards
  statCards = {
    colorScheme: {
      light: {
        root: {
          background: '#e5f6ff',
        }
      }
    }
  };

  constructor(
    private curationService: CurationService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.curationService.getStudyCount().subscribe((studyCount) => {
      this.totalStudies = studyCount.toLocaleString('en', { useGrouping: true });
      this.cdr.markForCheck();
    });
    this.curationService.getAssayCount().subscribe((assayCount) => {
      this.totalAssays = assayCount.toLocaleString('en', { useGrouping: true });
      this.cdr.markForCheck();
    });
    this.curationService.getDataCount().subscribe((dataCount) => {
      this.totalFiles = dataCount.toLocaleString('en', { useGrouping: true });
      this.cdr.markForCheck();
    });
    this.curationService.getProtocolCount().subscribe((protocolCount) => {
      this.totalProtocols = protocolCount.toLocaleString('en', { useGrouping: true });
      this.cdr.markForCheck();
    });
  }

}
